export enum ButtonTypes {
  Text = 'TextButton',
  RunFlowNode = 'RunFlowNodeButton',
  FlowFormButton = 'FlowFormButton',
  Share = 'Share',
  TriggerCall = 'TriggerCall',
  UserPropRedirect = 'UserPropRedirect',
  Reaction = 'Reaction',
  PalmsReaction = 'PalmsReaction',
  FingerUpReaction = 'FingerUpReaction',
  FingerDownReaction = 'FingerDownReaction',
  Link = 'Link',
}

export enum AvailableButtonsItems {
  Button = 'Button',
  Divider = 'Divider'
}
